import React from 'react';

import { useIntl } from 'react-intl-next';

import AkFlag, { type FlagProps } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/core/migration/error';
import { R300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { getProductDisplayName, type Product } from '../../common/ui/products';
import { withLocalIntl } from '../../common/utils/i18n/intl-provider';

import { messages } from './messages';

export type Props = {
	id: FlagProps['id'];
	onDismiss: FlagProps['onDismissed'];
	targetProduct: Product;
};

const SUPPORT_LINK = 'https://support.atlassian.com/contact/';

export const RequestAccessErrorFlag = withLocalIntl(
	({ onDismiss, targetProduct, ...props }: Props) => {
		const { formatMessage } = useIntl();

		return (
			<AkFlag
				{...props}
				icon={
					<ErrorIcon spacing="spacious" label="Error" color={token('color.icon.danger', R300)} />
				}
				onDismissed={onDismiss}
				title={formatMessage(messages.title, { product: getProductDisplayName(targetProduct) })}
				description={formatMessage(messages.description, {
					a: (chunks) => <a href={SUPPORT_LINK}>{chunks}</a>,
				})}
			/>
		);
	},
);
